var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13112 3.99799C5.76064 4.31233 5.5 4.78864 5.5 5.46695V5.96695H4.5V5.46695C4.5 4.50062 4.88546 3.74345 5.48414 3.23548C6.07195 2.73673 6.83788 2.5 7.58441 2.5C8.33095 2.5 9.09688 2.73674 9.68469 3.23549C10.2834 3.74346 10.6688 4.50062 10.6688 5.46695C10.6688 6.14824 10.4954 6.65679 10.2177 7.07321C9.98015 7.4296 9.67123 7.70556 9.41067 7.93831C9.3827 7.9633 9.35528 7.98779 9.32857 8.01183C9.03844 8.27294 8.79874 8.50594 8.62159 8.8189C8.44934 9.1232 8.31936 9.53543 8.31936 10.1658V10.6658H7.31936V10.1658C7.31936 9.38653 7.48306 8.80024 7.75134 8.3263C8.01471 7.861 8.36238 7.53603 8.65962 7.26852C8.68452 7.24611 8.70895 7.22419 8.7329 7.2027C9.00893 6.95499 9.22245 6.76338 9.3857 6.5185C9.5486 6.27415 9.66883 5.9604 9.66883 5.46695C9.66883 4.78865 9.40819 4.31234 9.03771 3.998C8.65636 3.67443 8.13008 3.5 7.58441 3.5C7.03874 3.5 6.51246 3.67442 6.13112 3.99799Z",
    fill: "#2767A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32364 12.491H8.32364V13.491H7.32364V12.491Z",
    fill: "#2767A9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion16);
export default __webpack_public_path__ + "static/media/Question16.83462fd4276571f471fa0ffef876c440.svg";
export { ForwardRef as ReactComponent };